module.exports = __webpack_public_path__ + "static/media/ctdc_logo.b134f7d3.svg";